import { PROJECT_SLUG } from '@monoimin/constants';

import { getStoryblokApiParams } from './getStoryblokApiParams';

import { GetStoriesParams, GetStoryParams } from './types';

const checkIsDraftModeEnabled = async (
  params: GetStoryParams | GetStoriesParams | undefined
) => {
  const { version } = params || {};

  if (version === 'published' || PROJECT_SLUG === 'passport-rating') {
    return false;
  }

  const { draftMode } = await import('next/headers');

  return (await draftMode()).isEnabled;
};

export const defineMergedParams = async <
  T extends GetStoryParams | GetStoriesParams
>(
  params?: T,
  isClient?: boolean
) => {
  const { locale = 'en', version, ...otherParams } = params || {};

  const isDraftModeEnabled = await checkIsDraftModeEnabled(params);

  const enablePreview = version ? version === 'draft' : isDraftModeEnabled;

  const storyblokApiParams = getStoryblokApiParams(
    enablePreview,
    locale,
    isClient
  );

  return Object.assign(storyblokApiParams, otherParams);
};

export default defineMergedParams;
